import FontFaceObserver from 'fontfaceobserver';

import BrowserStorage from '@module/browserstorage';
import Logger from '@module/logger';

// List fonts being used on the website
const fonts = [
  { name: 'FreightSans Pro Medium', props: {} },
  { name: 'FreightSans Pro Semibold', props: {} },
  { name: 'Actief Grotesque', props: {} },
  { name: 'GT Super WT', props: {} },
];

export const init = async () => {
  // On Safari, in private mode navigation, web storage is not available
  if (!BrowserStorage.isSupported) return;

  const className = 'fonts-loaded';
  const { classList } = document.documentElement;
  const onComplete = (className) => {
    classList.add(className);
    BrowserStorage.setItem('wt_fontsHaveBeenLoaded', true);
  };

  // If the fonts have already been loaded, skip this smart-swap
  // This is assuming a lot of things but should improve behaviour.
  if (BrowserStorage.getItem('wt_fontsHaveBeenLoaded')) {
    return onComplete(className);
  }

  // Already has the class, not sure why you got here
  // but let's complete and continue.
  if (Array.from(classList).indexOf(className) > -1) {
    return onComplete(className);
  }

  try {
    // Load all fonts
    await Promise.all(
      fonts.map(({ name, props }) => new FontFaceObserver(name, props).load())
    );
    onComplete(className);
  } catch (error) {
    Logger.error(error);
  }
};

export default init;
